import React from 'react';
import { AutoComplete as AntdAutoComplete, AutoCompleteProps } from 'antd';

import { PlaceholderAsLabel } from '~shared/ui/layout';

export const AutoComplete: React.FC<AutoCompleteProps> = ({ size = 'large', ...props }) => {
  return (
    <PlaceholderAsLabel placeholder={props.placeholder} value={props.value}>
      <AntdAutoComplete size={size} {...props} />
    </PlaceholderAsLabel>
  );
};
